import React from 'react';
import Modal from '~src/components/Modal';
import { brand } from '../../../../../../src/brand/brand';
import { Button } from '@nerdcoresdk/nerd-core-ui';

import styles from './twoFactorModal.module.css';

export default function TwoFactorModal({ handleCloseModal, handleContinue }) {
  const page = brand.pages.manageAccount.mfa;
  return (
    <Modal showClose={true} onClose={handleCloseModal} title={page.modal.title}>
      <div className={styles.modalWrapper}>
        <div className={styles.modalSubText} data-core-qa="mfaModalSubText">
          {page.modal.subText}
        </div>
        <div className={styles.modalButtonRow}>
          <Button
            className={styles.button}
            kind="outlined"
            data-core-qa="mfaModalButtonCancel"
            onClick={handleCloseModal}
          >
            {page.modal.cancelButtonText}
          </Button>
          <Button
            className={styles.button}
            kind="solid"
            data-core-qa="mfaModalButtonContinue"
            onClick={handleContinue}
          >
            {page.modal.continueButtonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
